import { useState, useEffect, useMemo } from 'react';
import type { SkinSeoulAdminProduct } from '../../../../../../models/ProductTypes';
import { SkinSeoulProductType } from '../../../../../../models/ProductTypes';
import type { ImageEditMode } from '../types';
import { PublishedImagePanelPdp } from './PublishedImagePanelPdp';
import { PublishedImagePanelThu } from './PublishedImagePanelThu';

interface PublishedImagePanelProps {
  readonly editMode: ImageEditMode;
  readonly productsBySku: SkinSeoulAdminProduct[];
  readonly onRefetchProducts?: () => void;
  readonly recentlyPublishedSkus?: Set<string>;
  readonly publishingSkus?: Set<string>;
}

export const PublishedImagePanel = ({
  editMode,
  productsBySku,
  onRefetchProducts,
  recentlyPublishedSkus = new Set(),
  publishingSkus = new Set(),
}: PublishedImagePanelProps) => {
  const [imageRefreshKey, setImageRefreshKey] = useState(Date.now());

  useEffect(() => {
    setImageRefreshKey(Date.now());
  }, [productsBySku]);

  // Extract published PDP images from first SKU only (shared across all SKUs)
  const publishedPdpImages = useMemo(() => {
    const firstProduct = productsBySku.find(
      (p) => p.type === SkinSeoulProductType.Variable || p.type === SkinSeoulProductType.Simple,
    );
    if (firstProduct?.learnMoreUrl && Array.isArray(firstProduct.learnMoreUrl)) {
      return firstProduct.learnMoreUrl;
    }
    return [];
  }, [productsBySku]);

  const handleRefreshImages = () => {
    setImageRefreshKey(Date.now());
    if (onRefetchProducts) {
      onRefetchProducts();
    }
  };

  return (
    <div
      style={{
        width: '360px',
        flexShrink: 0,
        background: '#ffffff',
        overflowY: 'auto',
        borderLeft: '1px solid #dee2e6',
        display: 'flex',
        padding: '20px',
        flexDirection: 'column',
      }}
    >
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {editMode === 'pdp' && (
          <PublishedImagePanelPdp
            publishedPdpImages={publishedPdpImages}
            productsBySku={productsBySku}
            imageRefreshKey={imageRefreshKey}
            onRefreshImages={handleRefreshImages}
          />
        )}

        {editMode === 'thu' && (
          <PublishedImagePanelThu
            productsBySku={productsBySku}
            imageRefreshKey={imageRefreshKey}
            recentlyPublishedSkus={recentlyPublishedSkus}
            publishingSkus={publishingSkus}
            onRefreshImages={handleRefreshImages}
          />
        )}
      </div>
    </div>
  );
};
